module.exports = __webpack_public_path__ + "static/media/star_icon.64f5c447.svg";